import styled from "styled-components";
import { desktop } from "../../constants/responsive";
import { device } from "../../stylesheet/breakpoints";

type Props = {
  height?: number | null;
};

export const Container = styled.div<Props>`
  width: 100%;
  margin: 0 auto;
  padding: 10px;
  background-color: var(--bg-color);

  @media ${device.mobile} {
    max-height: ${({ height }) => height ? height + "px" : "100vh"};
    height: 100vh;
  }

  @media ${device.desktop} {
    /* position: absolute;
    left: 50%;
    top: 50%; */
    /* transform: translate(-50%, -50%);
    width: calc(100% - 40px); */
    width: 100%;
    min-width: 800px;
    height: calc(100vw * 0.5625);
    max-height: calc(${desktop}px * 0.5625);
    max-width: ${desktop}px;
    aspect-ratio: 80 / 45;
    padding: 20px;
    border-radius: 10px;
  }
`;

export const ContainerBox = styled.div<Props>`
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;

   & ${Container} {
    -webkit-box-shadow: 0px 0px 14px 1px rgba(0,0,0,0.14);
    -moz-box-shadow: 0px 0px 14px 1px rgba(0,0,0,0.14);
    box-shadow: 0px 0px 14px 1px rgba(0,0,0,0.14);
   }

    @media ${device.mobile} {
      height: ${({ height }) => height ? height + "px" : "100vh"};
    }
`;